import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import { LoadableFormationDetailRulesPage } from '../../scenes/FormationComponents/FormationDetailRulesPage/LoadableFormationDetailRulesPage';
import { LoadableFormationDetailsPdfPage } from '../../scenes/FormationComponents/FormationDetailsPdfPage/LoadableFormationDetailsPdfPage';
import { LoadableFormationDetailsQuizPage } from '../../scenes/FormationComponents/FormationDetailsQuizPage/LoadableFormationDetailsQuizPage';
import { LoadableFormationDetailsSatisfactionSurveyPage } from '../../scenes/FormationComponents/FormationDetailsSatisfactionSurveyPage/LoadableFormationDetailsSatisfactionSurveyPage';
import { LoadableFormationDetailsVideoPage } from '../../scenes/FormationComponents/FormationDetailsVideoPage/LoadableFormationDetailsVideoPage';
import { LoadableFormationDetailPage } from '../../scenes/FormationDetailPage/LoadableFormationDetailPage';
import { LoadableQuizDetailsPage } from '../../scenes/QuizDetailsPage/LoadableQuizDetailsPage';

const FormationRouter = ({ defaultRoute, Page403 }) => (
    <Switch>
        <Route exact path="/formations/details/:id" component={LoadableFormationDetailPage} Page403={Page403} />
        <Route
            exact
            path="/formations/details/:id/rules"
            component={LoadableFormationDetailRulesPage}
            Page403={Page403}
        />
        <Route
            exact
            path="/formations/details/:id/pdfs"
            component={LoadableFormationDetailsPdfPage}
            Page403={Page403}
        />
        <Route
            exact
            path="/formations/details/:id/videos"
            component={LoadableFormationDetailsVideoPage}
            Page403={Page403}
        />

        {/* QUIZ ROUTES  */}
        <Route
            exact
            path="/formations/details/:id/quiz"
            component={LoadableFormationDetailsQuizPage}
            Page403={Page403}
        />

        <Route
            exact
            path="/formations/details/:id/quiz/details/:quiz_id"
            component={LoadableQuizDetailsPage}
            Page403={Page403}
        />

        <Route
            exact
            path="/formations/details/:id/satisfaction"
            component={LoadableFormationDetailsSatisfactionSurveyPage}
            Page403={Page403}
        />

        <Redirect to={defaultRoute} />
    </Switch>
);

FormationRouter.propTypes = {
    defaultRoute: PropTypes.string.isRequired,
    Page403: PropTypes.func.isRequired,
};

export { FormationRouter };
